export const ROLES = {
  MAIN: 'main',
  REMOTE: 'remote'
}

export const role = window.location.hostname === 'localhost' ? ROLES.MAIN : ROLES.REMOTE
